import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialPinterest = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M8.236 21.734s-.224-2.608.024-3.747c.213-.98 1.378-6.24 1.378-6.24s-.351-.752-.351-1.864c0-1.745.945-3.048 2.124-3.048 1.003 0 1.487.804 1.487 1.768 0 1.077-.642 2.687-.974 4.18-.276 1.25.587 2.269 1.74 2.269 2.087 0 3.692-2.353 3.692-5.75 0-3.006-2.021-5.107-4.907-5.107-3.34 0-5.302 2.679-5.302 5.448 0 1.08.389 2.235.874 2.865q.063.072.085.168a.4.4 0 0 1-.003.192c-.09.397-.288 1.25-.327 1.424-.052.229-.17.278-.393.167C5.916 13.729 5 11.438 5 9.597 5 5.636 7.69 2 12.76 2 16.832 2 20 5.103 20 9.25c0 4.326-2.551 7.809-6.095 7.809-1.19 0-2.308-.662-2.691-1.443 0 0-.59 2.398-.732 2.985C10.205 19.74 8.96 22 8.96 22z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialPinterest) as SvgIcon;
export { ForwardRef as ReactComponent };
